/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react'

import { PricingList } from '../common/Helper'
import { GreenCheckMark } from '../common/Icons'
import PrimaryHeading from '../custom-ui/PrimaryHeading'

const Pricing = () => {
  const [isPriceSetAnnualy, setIsPriceSetAnnualy] = useState(true)
  return (
    <div className="container py-24">
      {' '}
      <PrimaryHeading>Pricing</PrimaryHeading>
      <div className=" my-6 flex items-center justify-center gap-x-[18px] sm:my-9">
        <button
          onClick={() => setIsPriceSetAnnualy(false)}
          className={`text-base font-normal leading-normal tracking-md transition-all duration-300 max-[576px]:text-sm max-[576px]:tracking-sm sm:text-lg sm:tracking-lg ${
            isPriceSetAnnualy ? ' opacity-30 hover:opacity-100' : ''
          }`}
        >
          Billed Monthly
        </button>{' '}
        <span
          onClick={() => setIsPriceSetAnnualy(!isPriceSetAnnualy)}
          className={`relative inline-block h-[30px] w-[56px] scale-75 cursor-pointer rounded-3xl bg-blue after:absolute after:top-1/2 after:h-4 after:w-4 after:-translate-y-1/2 after:rounded-full after:bg-white after:transition-all after:duration-300 sm:scale-100 ${
            isPriceSetAnnualy ? 'after:right-[7px]' : 'after:right-[34px]'
          }`}
        ></span>
        <button
          onClick={() => setIsPriceSetAnnualy(true)}
          className={`text-base font-normal leading-normal tracking-md transition-all duration-300 max-[576px]:text-sm max-[576px]:tracking-sm sm:text-lg sm:tracking-lg ${
            isPriceSetAnnualy ? ' ' : 'opacity-30 hover:opacity-100'
          }`}
        >
          Billed Annually
        </button>
      </div>
      <div className="flex flex-wrap justify-center gap-y-3">
        {PricingList.map((obj, i) => (
          <div
            className="w-full px-1.5 md:w-[50%] lg:w-[42%] xl:w-[34%]"
            key={i}
          >
            <div className="flex h-[100%] flex-col rounded-xl border border-solid  border-[#DBDBDB] bg-white p-4 shadow-[4px_4px_20px_0px_#0000001A] transition-all duration-300">
              <div className=" flex grow flex-col">
                <div className=" flex items-center justify-between pb-4">
                  <PrimaryHeading class=" !leading-[1]">
                    {obj.planType}
                  </PrimaryHeading>
                  {obj.Offer && (
                    <span className=" inline-block rounded-2xl bg-[#8DBE76] px-3 py-2 text-base font-semibold !leading-[0.75] text-white max-[576px]:py-1 max-[576px]:text-sm sm:text-lg">
                      {obj.Offer}
                    </span>
                  )}
                </div>
                <p className=" track mb-2 text-lg font-semibold leading-120 tracking-lg text-blue">
                  {obj.planInfo}
                </p>
              </div>
              <div>
                <ul className=" mb-4 flex flex-col gap-y-3 border-y border-solid border-y-blue py-6">
                  {obj.specifications &&
                    obj.specifications.map((list, index) => (
                      <li
                        key={index}
                        className="flex items-center gap-x-2"
                      >
                        <span>
                          <GreenCheckMark />
                        </span>
                        <p className="common-pera !text-left !opacity-100">
                          {list}
                        </p>
                      </li>
                    ))}
                </ul>
                <div className="mt-6 flex flex-col justify-end ">
                  <div className="flex items-center justify-end">
                    <span className="-mb-1 text-[22px] font-semibold leading-normal tracking-2xl text-blue">
                      $
                    </span>
                    <h2 className="text-[54px] font-semibold leading-[1] tracking-5xl text-blue">
                      {!isPriceSetAnnualy && i === 1
                        ? obj.price
                        : i === 0
                          ? obj.price
                          : '40'}
                      {/* {obj.price} */}
                    </h2>
                  </div>
                  <p className="common-pera !text-end ">per user, per month</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Pricing
